"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProcessOrphanSteps = void 0;
var path_measurers_1 = require("../path-walkers/path-measurers");
var process_to_nodemap_1 = require("./process-to-nodemap");
function getProcessOrphanSteps(content, stepsBlockedAt) {
    if (stepsBlockedAt == null) {
        return new Set();
    }
    var nodeMap = process_to_nodemap_1.convertProcessToNodeMap(content)[0];
    var _a = path_measurers_1.getFartherEndingPath("start", nodeMap), visitedNodes = _a[1];
    return path_measurers_1.getOrphanNodes(nodeMap, visitedNodes);
}
exports.getProcessOrphanSteps = getProcessOrphanSteps;
